import { render } from "./materialShare.vue?vue&type=template&id=32c2e4d6"
import script from "./materialShare.vue?vue&type=script&lang=js"
export * from "./materialShare.vue?vue&type=script&lang=js"

import "./materialShare.vue?vue&type=style&index=0&id=32c2e4d6&lang=scss"

import exportComponent from "F:\\webStorm workspace\\ujk_tangying\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__